import React, { useState } from 'react';
import DENTModalOverviewPathologyButtons from '../DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyButtons';
// @ts-ignore
import styles from './DENTModalOverviewPathology.module.scss';
import DENTModalOverviewSurfaces from '../DENTModalOverviewSurfaces/DENTModalOverviewSurfaces';
import DENTModalOverviewActionButtons from '../DENTModalOverviewActionButtons/DENTModalOverviewActionButtons';
import { useDENTContext } from '../../Services/DENTContext';
import {
	PATHOLOGY_BUTTON_OPTIONS,
	PathologyOption,
} from '../../Helpers/pathology/pathologyButtonOptions';
import usePathologySurfaceHandler from '../../Hooks/Tooth/Pathology/usePathologySurfaceHandler';
import { SurfaceOperation } from '../../Enums/SurfaceOperation.enum';
import { PathologyItem } from '../../Enums/PathologyItem.enum';
import { ToothWearType } from '../DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyToothWear';

interface Props {
	onClose: () => void;
}

const DENTModalOverviewPathology = ({ onClose }: Props) => {
	const [option, setOption] = useState<PathologyOption>(
		PATHOLOGY_BUTTON_OPTIONS[0],
	);
	const [toothWearType, setToothWearType] = useState<
		ToothWearType | undefined
	>();
	const { activeTooth, handleUpdateTooth } = useDENTContext();

	const surfaceHandler = usePathologySurfaceHandler(
		option.value,
		toothWearType,
	);

	const handleSubmit = async () => {
		if (!activeTooth?.pathology) return;
		handleUpdateTooth({
			pathology: activeTooth.pathology,
		});
	};

	const handleSelectOption = (option: PathologyOption) => {
		surfaceHandler.handleSelectSurface([], SurfaceOperation.REPLACE);
		setToothWearType(undefined);
		setOption(option);
	};

	if (!activeTooth) {
		return <></>;
	}

	return (
		<div className={styles.container}>
			<DENTModalOverviewSurfaces
				onSelectSurface={surfaceHandler.handleSelectSurface}
				surfaces={surfaceHandler}
			/>
			<div className={styles.buttonsContainer}>
				<DENTModalOverviewPathologyButtons
					selectedOption={option}
					setSelectedOption={handleSelectOption}
					options={PATHOLOGY_BUTTON_OPTIONS}
					onClose={onClose}
					decayIndex={surfaceHandler.decayIndex ?? 0}
					setDecayIndex={surfaceHandler.setDecayIndex ?? (() => {})}
					onToothWearTypeChange={
						option.value === PathologyItem.TOOTH_WEAR
							? setToothWearType
							: undefined
					}
				/>
				<DENTModalOverviewActionButtons onSubmit={handleSubmit} />
			</div>
		</div>
	);
};

export default DENTModalOverviewPathology;
